/**
 * Universal disclaimer block per F-FE-CORPUS-BROWSER §3.3 (verbatim).
 *
 * MANDATORY render on:
 *   - /tim-kiem page footer (once)
 *   - /van-ban/:id every tab footer (each tab uses this component)
 *
 * legal-upl HARD VETO trigger if missing or content drifts. Content must be
 * verbatim - DO NOT shorten or paraphrase.
 *
 * Visual: text-xs muted color, full-width, end-of-page (or sticky-footer
 * within tab container).
 */

import { Link } from 'react-router-dom';

export function CorpusDisclaimerBlock({ compact = false }: { compact?: boolean }) {
  return (
    <aside
      role="note"
      aria-label="Tuyên bố miễn trừ trách nhiệm pháp lý"
      style={{
        marginTop: 32,
        padding: compact ? '14px 16px' : '20px 24px',
        background: 'var(--asklaw-cream-deep)',
        border: '1px solid var(--asklaw-border)',
        borderRadius: 12,
        color: 'var(--asklaw-muted)',
        fontSize: 12.5,
        lineHeight: 1.6,
        fontFamily: 'var(--font-sans)',
      }}
    >
      <p
        style={{
          margin: '0 0 8px',
          fontWeight: 700,
          color: 'var(--asklaw-ink-soft)',
          letterSpacing: '0.02em',
          textTransform: 'uppercase',
          fontSize: 11.5,
        }}
      >
        Đây là nội dung tham khảo. Không phải tư vấn pháp lý.
      </p>
      <p style={{ margin: '0 0 8px' }}>
        Asklaw cung cấp thông tin văn bản pháp luật dưới dạng tham khảo, dựa trên cơ sở
        dữ liệu của vbpl.vn (Bộ Tư pháp). Nội dung KHÔNG thay thế cho tư vấn pháp lý
        chuyên nghiệp.
      </p>
      <p style={{ margin: '0 0 8px' }}>
        Theo Luật Luật sư 65/2006/QH11 và Luật sửa đổi 20/2012/QH13, việc tư vấn pháp lý
        có tính thương mại chỉ có thể được cung cấp bởi luật sư có thẻ thẻ hành nghề.
      </p>
      <p style={{ margin: '0 0 8px' }}>
        Bài viết KHÔNG tạo lập quan hệ luật sư - khách hàng.
      </p>
      <p style={{ margin: 0 }}>
        Dữ liệu xử lý tuân thủ Luật AI 2026 và Luật Bảo vệ Dữ liệu Cá nhân 2026.{' '}
        <Link to="/privacy" style={{ color: 'var(--asklaw-blue)' }}>
          Xem chính sách bảo mật
        </Link>
        .
      </p>
    </aside>
  );
}
